import React from "react";
import DeleteBtn from "../../../Utilities/DeleteBtn";
import EmptyState from "../../../Utilities/EmptyState";
import FormLabel from "../../../Utilities/FormLabel";
import ColumnCard from "./ColumnCard";

// ── RowsConfiguration ─────────────────────────────────────────────────────────
// Renders the fixed-rows list. When dynamicColumns is true each row also shows
// its own column grid with add/delete controls.
const RowsConfiguration = ({
  rows,
  dynamicColumns,
  unitMasters,
  onAddRow,
  onRemoveRow,
  onUpdateRowLabel,
  onAddColumnToRow,
  onRemoveColumnFromRow,
  onUpdateRowColumn,
}) => (
  <div className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <FormLabel icon="fas fa-list">Rows Configuration</FormLabel>
      <button type="button" className="btn btn-primary btn-sm" onClick={onAddRow}>
        <i className="fas fa-plus me-1"></i> Add Row
      </button>
    </div>

    <div className="row-list">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="mb-3 p-3 border rounded bg-white shadow-sm">
          {/* Row label + delete */}
          <div className="d-flex align-items-end gap-2 mb-3">
            <div className="flex-grow-1">
              <label className="form-label small fw-bold text-primary mb-1">
                Row {rowIndex + 1} Label
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter row label"
                value={row.label}
                onChange={(e) => onUpdateRowLabel(rowIndex, e.target.value)}
              />
            </div>
            <DeleteBtn onClick={() => onRemoveRow(rowIndex)} title="Remove Row" size={38} />
          </div>

          {/* Per-row columns — only when each row has its own dynamic column set */}
          {dynamicColumns && (
            <div className="mt-3 p-3 border-top">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="small fw-bold text-secondary">Columns for this row</span>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  style={{ fontSize: "11px" }}
                  onClick={() => onAddColumnToRow(rowIndex)}
                >
                  <i className="fas fa-plus me-1"></i> Add Column
                </button>
              </div>
              <div className="row g-2">
                {row.columns.map((col, colIndex) => (
                  <div key={colIndex} className="col-6">
                    <ColumnCard
                      col={col}
                      onLabelChange={(val) => onUpdateRowColumn(rowIndex, colIndex, "label", val)}
                      onTypeChange={(val) => onUpdateRowColumn(rowIndex, colIndex, "data_type", val)}
                      onDelete={() => onRemoveColumnFromRow(rowIndex, colIndex)}
                      onOptionsChange={(tags) => onUpdateRowColumn(rowIndex, colIndex, "dropdown_options", tags)}
                      showType
                      unitMasters={unitMasters}
                    />
                  </div>
                ))}
              </div>
              {row.columns.length === 0 && <EmptyState message="No columns defined for this row." />}
            </div>
          )}
        </div>
      ))}
      {rows.length === 0 && <EmptyState message="No rows added yet." />}
    </div>
  </div>
);

export default RowsConfiguration;
